import { VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import React from 'react';
import { useShopStyles } from '~/shared/styles';

export type GenericSpecialProps = {
  name: string;
};

export const GenericSpecial = ({ name }: GenericSpecialProps) => {

    const { section_background, primary_color, pressable_text } = useShopStyles();

    return (
        <VStack
            w={'100%'}
            h={'120px'}
            alignItems={'center'}
            justifyContent={'center'}
            bg={section_background}
            rounded={'lg'}
        >
            <Caption
                position={'absolute'}
                zIndex={-1}
                top={0}
                left={0}
                bottom={0}
                right={0}
                fontSize={36}
                fontWeight={700}
                color={primary_color}
                textAlign={'center'}
            >
                { name.toUpperCase() }
            </Caption>
            <Caption
                fontSize={24}
                fontWeight={700}
                color={pressable_text}
            >
                { name.toUpperCase() }
            </Caption>
        </VStack>
    );
};
